// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__19_Lb","inputWrap":"Table_inputWrap__2yU9y","col":"Table_col__2yRbI","bmiTooltip":"Table_bmiTooltip__3slIZ"};